import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageCarouselProps {
  images: {
    src: string;
    alt: string;
  }[];
  checkoutUrl?: string;
}
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45711849652385:1';
export function ImageCarousel({
  images,
  checkoutUrl = CHECKOUT_URL
}: ImageCarouselProps) {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent(c => c === 0 ? images.length - 1 : c - 1);
  const next = () => setCurrent(c => c === images.length - 1 ? 0 : c + 1);
  return <div className="relative w-full max-w-2xl mx-auto" data-id="element-32">
      <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block relative aspect-[3/4] w-full overflow-hidden rounded-xl shadow-lg bg-white border-2 border-brand-border" data-id="element-33">
        <img src={images[current].src} alt={images[current].alt} className="w-full h-full object-contain transition-opacity duration-300" data-id="element-34" />
      </a>

      <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-brand-coral rounded-full p-2 shadow-md transition-all hover:scale-110 z-10 border border-brand-border" aria-label="Anterior" data-id="element-35">
        <ChevronLeft className="w-6 h-6" data-id="element-36" />
      </button>
      <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-brand-coral rounded-full p-2 shadow-md transition-all hover:scale-110 z-10 border border-brand-border" aria-label="Siguiente" data-id="element-37">
        <ChevronRight className="w-6 h-6" data-id="element-38" />
      </button>

      <div className="flex justify-center gap-2 mt-4" data-id="element-39">
        {images.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-3 h-3 rounded-full transition-all ${i === current ? 'bg-brand-coral scale-125' : 'bg-brand-peach-dark hover:bg-brand-coral/50'}`} aria-label={`Imagen ${i + 1}`} data-id="element-40" />)}
      </div>

      <p className="text-center text-sm text-brand-brown-light mt-2" data-id="element-41">
        {current + 1} / {images.length}
      </p>
    </div>;
}